import { queryOptions, useQuery } from "@tanstack/react-query";
import { get } from "lodash";
import { apiBase } from "../utils/apiBase";
import { REFERENCE_QUERY_OPTIONS } from "./queryClient";

export const pipedriveUsersQuery = queryOptions({
  queryKey: ["pipedriveUsers"],
  queryFn: () =>
    apiBase
      .get("pipedrive-users")
      .then((res) => get(res, "data.pipedrive_users", [])),
  ...REFERENCE_QUERY_OPTIONS,
  meta: { errorMessage: "Failed to load pipedrive users." },
});

export const usePipedriveUsers = () => useQuery(pipedriveUsersQuery);
